import React from 'react';
import Dropzone from './DropZone.js';
import Header from '../header';
import Analyze from './analyze';
import Tableanalyze from './table-analyze';
// function Fileupload() {

class Fileupload extends React.Component{

    constructor(props) {
        super(props)
        this.state={
            img_folder:"folderName1",
            ModelName:[],
            classifyModel:[],
            colorModel:[],
            imgAlignment:[],
            loginSuccess:this.props.loginSuccess,
            imagesUploaded:false,
            analyseClick:false,
            uploadedFileName:"zipFileName.zip",
            selectedExcel:"",
            Blank_Imprint : "",
            Shot_View:"",
            Single_Multi : "",
            Color_Categorization : "",
            ImageCompare : ""           
        }
        this.selectedModel=this.selectedModel.bind(this)
        this.classifyValues=this.classifyValues.bind(this)
        this.GetCheckboxClickedValue=this.GetCheckboxClickedValue.bind(this)
        this.colorModel=this.colorModel.bind(this)
        this.imgAlignment=this.imgAlignment.bind(this)
        this.UpdateUploaded=this.UpdateUploaded.bind(this)
        this.analyseClick=this.analyseClick.bind(this)
        this.changeUploadedFileName=this.changeUploadedFileName.bind(this)
        this.selectedExcel=this.selectedExcel.bind(this)
    }

    UpdateUploaded(fileUpload){
        this.setState({
            imagesUploaded:fileUpload
        })
    }

    selectedModel(selectedValue){ 
        this.setState({
            ModelName:selectedValue
        })
    }

    classifyValues(classifyModel){
        this.setState({
            classifyModel :classifyModel
        })
    }

    GetCheckboxClickedValue(Model,CheckBoxValues){
        if(Model == "Blank/Imprint"){
            this.setState({
                Blank_Imprint : CheckBoxValues
            })
        }
        else if(Model == "Shot"){
            this.setState({
                 Shot_View : CheckBoxValues 
           })
        }
        else if(Model == "Single/Multi"){
            this.setState({
                 Single_Multi : CheckBoxValues
            })
        }
        else if(Model == "dominant_colour"){
            this.setState({
                 Color_Categorization : CheckBoxValues
            })
        }
        else if(Model == "ImgComparison"){
            this.setState({
                ImageCompare : CheckBoxValues
            })
        }
    }

    colorModel(colorModel){
        this.setState({           
            colorModel:colorModel
        })
    }

    imgAlignment(imgAlignment){
        this.setState({            
            imgAlignment:imgAlignment
        })
    }

    analyseClick(analyseClick){
        this.setState({            
            analyseClick:analyseClick
        })
    }

    changeUploadedFileName(fileName){
        this.setState({            
            uploadedFileName:fileName
        })
    }

    selectedExcel(selectedExcel){
        this.setState({            
            selectedExcel:selectedExcel
        })
    }

    render(){
        return (
            <div >
             <Header pagename="IMAGE METRICS"/>
            <div className="content ">
            
            {this.state.analyseClick==false?
             <React.Fragment>
                 <Dropzone props={this.state} UpdateUploaded={this.UpdateUploaded} changeUploadedFileName={this.changeUploadedFileName} /> 
                    <Analyze props={this.state} selectedModel={this.selectedModel} classifyValues={this.classifyValues} 
                    imgAlignment={this.imgAlignment} colorModel={this.colorModel} analyseClick={this.analyseClick} selectedExcel={this.selectedExcel} 
                    CheckBoxValue = {this.GetCheckboxClickedValue}/>  
             </React.Fragment>
            :
                <Tableanalyze props={this.state} />
            }
                      
                     
            </div>
        </div>
        );
    }

}
   
  export default Fileupload;